<template>
  <div class="steps">
    <div class="step">
      <div class="demandInfo ">
        <span class="circle circleOne" id="stepOne" v-if="this.active==='0'">1</span>
        <span  id="stepOne" v-if="this.active==='1'"><i class="iconfont icon-chenggong-icon icon"></i></span>
        <span class="moneyDemandTip" id="stepOneD">融资需求</span>
      </div>
      <div class="lineShell ">
        <span :class="setLine()"></span>
        <span class="line"></span>
      </div>
      <div class="loaderInfoBox ">
        <span :class="setTwoClass()" id="stepTwo">2</span>
        <span :class="setTwoStepClass()" id="stepTwoL">借款人信息</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'Steps',
  props: ['active'],
  data() {
    return {};
  },
  methods: {
    setTwoClass() {
      if (this.active === '0') {
        return 'circle circleTwo';
      }
      return ' circle circleOne';
    },
    setTwoStepClass() {
      if (this.active === '0') {
        return 'loaderInfoTip';
      }
      return 'moneyDemandTip';
    },
    setLine() {
      if (this.active === '0') {
        return 'lineTop widthHalf';
      }
      return 'lineTop widthAll';
    },
  },
};
</script>
<style scoped>
/* 步骤条 */
.step {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 51px;
  padding: 0 15px;
  background-color: #fff;

}
.circle {
  display: inline-block;
  width: 16px;
  height: 16px;
  padding: 1px;
  font-size: 12px;
  line-height: 15px;
  text-align: center;
  border-radius: 50%;
}
.circleOne {
  color: #fff;
  background-color: #f55348;
  border: 1px solid #f55348;
}
.demandInfo {
  position: absolute;
  top:0;
  left: 27px;
  height: 51px;
  line-height: 51px;
}
.moneyDemandTip {
  padding-left: 5px;
  color: #f55348;
  font-size: 12px;

  /* padding-right: 9px; */
}
.icon {
  color: #f55348;
  font-size: 20px;
  vertical-align: bottom;
}
.lineShell {
  position: relative;
  height: 51px;
  margin-right: 88px;
  margin-left: 88px;
  line-height: 45px;
}

.line {
  position: absolute;
  top: 28px;
  left: 0;
  display: inline-block;
  width: 100%;
  height: 2px;
  background: #f6f6f6;
}
.lineTop {
  position: absolute;
  top: 28px;
  left: 0;
  z-index:1;
  display: inline-block;
  width: 100%;
  height: 2px;
  background-image: linear-gradient(90deg, #f5514a 0%, #f5683c 100%);
}
.widthHalf {
  position: absolute;
  top: 28px;
  left: 0;
  z-index:1;
  width: 50%;
}
.widthAll {
  width: 100%;
}
.circleTwo {
  background-color: #fff;
  border: 1px solid #495060;

}
.loaderInfoBox {
  position: absolute;
  top:0;
  right: 15px;
  height: 51px;
  line-height: 51px;
  text-align: center;
}
.loaderInfoTip {
  padding-left: 5px;
  color: #9ea7b4;
  font-size: 12px;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
</style>
